"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableActionsCell = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var BcDataTableActionsCell = (function () {
    function BcDataTableActionsCell(bcDataTableConfig) {
        this.bcDataTableConfig = bcDataTableConfig;
        this.rowActionsCb = null;
        if (bcDataTableConfig.actions && bcDataTableConfig.actions.rowAction) {
            this.rowActionsCb = bcDataTableConfig.actions.rowAction;
        }
    }
    BcDataTableActionsCell.prototype.rowsActions = function (callback) {
        this.rowActionsCb = callback;
    };
    BcDataTableActionsCell.prototype.callRowActions = function (_rows, object) {
        if (this.rowActionsCb) {
            this.rowActionsCb(_rows, object);
        }
    };
    BcDataTableActionsCell.prototype.render = function (cell) {
        var amountActions = cell.value.length;
        if (amountActions > 0 && cell.value.length <= bc_data_table_constants_1.BcDataTableConstansts.MAXIMUN_ITEMS_ICONS_ACTIONS) {
            return this.createIconsButtonActions(cell);
        }
        if (amountActions > bc_data_table_constants_1.BcDataTableConstansts.MAXIMUN_ITEMS_ICONS_ACTIONS) {
            return this.createFloatMenuActions(cell);
        }
        return this.createEmptyActions(cell);
    };
    BcDataTableActionsCell.prototype.createSpanFloatMenu = function (spanText) {
        var aElement = document.createElement(common_constants_1.BcCommonConstants.HREF_TAG);
        var spanElement = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        spanElement.classList.add('bc-float-menu-main-text');
        spanElement.innerHTML = spanText;
        aElement.appendChild(spanElement);
        return aElement;
    };
    BcDataTableActionsCell.prototype.createEmIcon = function (icon) {
        var emElement = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        emElement.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS);
        emElement.innerHTML = icon;
        return emElement;
    };
    BcDataTableActionsCell.prototype.createLiElement = function (action) {
        var liElement = document.createElement(common_constants_1.BcCommonConstants.LI_TAG);
        if (action.disabled) {
            liElement.classList.add(common_constants_1.BcCommonConstants.BC_FLOAT_MENU_OPTION_DISABLED_CLASS);
        }
        else {
            liElement.classList.add(common_constants_1.BcCommonConstants.BC_FLOAT_MENU_OPTION_CLASS);
            liElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.handleActionClick.bind(this));
            liElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, this.handleActionClick.bind(this));
        }
        liElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_ID, action.actionId);
        liElement.appendChild(this.createEmIcon(action.icon));
        liElement.appendChild(this.createSpanFloatMenu(action.text));
        return liElement;
    };
    BcDataTableActionsCell.prototype.createUlElement = function (cell) {
        var _this = this;
        var ulElement = document.createElement(common_constants_1.BcCommonConstants.UL_TAG);
        cell.value.forEach(function (action) {
            ulElement.appendChild(_this.createLiElement(action));
        });
        return ulElement;
    };
    BcDataTableActionsCell.prototype.createSectionContentFloatMenu = function (cell) {
        var sectionElement = document.createElement(common_constants_1.BcCommonConstants.SECTION_TAG);
        sectionElement.classList.add('bc-float-menu-content');
        sectionElement.appendChild(this.createUlElement(cell));
        return sectionElement;
    };
    BcDataTableActionsCell.prototype.createDivArrowFloatMenu = function () {
        var divElement = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divElement.classList.add(common_constants_1.BcCommonConstants.BC_FLOAT_MENU_ARROW_CLASS);
        return divElement;
    };
    BcDataTableActionsCell.prototype.createFloatMenu = function (cell) {
        var divElement = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divElement.classList.add(common_constants_1.BcCommonConstants.BC_FLOAT_MENU_CLASS, common_constants_1.BcCommonConstants.BC_FLOAT_MENU_ARROW_LEFT_CLASS);
        divElement.appendChild(this.createDivArrowFloatMenu());
        divElement.appendChild(this.createSectionContentFloatMenu(cell));
        return divElement;
    };
    BcDataTableActionsCell.prototype.createFloatMenuActions = function (cell, isGroup) {
        if (isGroup === void 0) { isGroup = false; }
        var divContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_TYPE);
        var newCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        var actionDefault = {
            icon: 'secondary-menu',
            text: 'button float Menu',
            actionId: 'id-icon-button-float-menu',
        };
        var iconButton = this.createIconButton(actionDefault);
        var floatMenu = this.createFloatMenu(cell);
        iconButton.querySelector(common_constants_1.BcCommonConstants.BUTTON_TAG).after(floatMenu);
        var button = iconButton.querySelector(common_constants_1.BcCommonConstants.BUTTON_TAG);
        button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            if (!!floatMenu.querySelector(".".concat(common_constants_1.BcCommonConstants.BC_FLOAT_MENU_CONTENT_ACTIVE_CLASS))) {
                iconButton
                    .querySelector("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG))
                    .classList.add("".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED));
            }
            else if (iconButton
                .querySelector("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG))
                .classList.contains("".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED))) {
                iconButton
                    .querySelector("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG))
                    .classList.remove("".concat(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_SELECTED));
            }
        });
        if (isGroup) {
            return iconButton;
        }
        ;
        divContainer.appendChild(iconButton);
        newCell.appendChild(divContainer);
        return newCell;
    };
    BcDataTableActionsCell.prototype.createEmptyActions = function (cell) {
        var newCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        newCell.textContent = '-';
        return newCell;
    };
    BcDataTableActionsCell.prototype.createIconsButtonActions = function (cell) {
        var _this = this;
        var divContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        divContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_TYPE);
        var newCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        var actions = cell.value;
        var buttons = actions.map(function (action) {
            if (action.value) {
                return _this.createFloatMenuActions(action, true);
            }
            return _this.createIconButton(action);
        });
        buttons.forEach(function (button, index) {
            if (!actions[index].disabled && !actions[index].value) {
                button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                    _this.handleActionClick(event);
                });
            }
        });
        divContainer.append.apply(divContainer, buttons);
        newCell.appendChild(divContainer);
        return newCell;
    };
    BcDataTableActionsCell.prototype.createIconButton = function (action) {
        var iconButtonElement = document.createElement(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_TAG);
        var buttonElement = this.getButton(action);
        iconButtonElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_ID, action.actionId);
        iconButtonElement.appendChild(buttonElement);
        return iconButtonElement;
    };
    BcDataTableActionsCell.prototype.getIcon = function (action) {
        var icon = document.createElement(common_constants_1.BcCommonConstants.I_TAG);
        icon.classList.add(common_constants_1.BcCommonConstants.ICONS_CLASS);
        icon.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_ID, action.actionId);
        icon.textContent = action.icon;
        return icon;
    };
    BcDataTableActionsCell.prototype.getButton = function (action) {
        var buttonElement = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        buttonElement.classList.add(common_constants_1.BcCommonConstants.BC_ICON_BUTTON_CLASS, common_constants_1.BcCommonConstants.BC_ICON_BUTTON_MEDIUM_CLASS, common_constants_1.BcCommonConstants.BC_ICON_BUTTON_GHOST_CLASS, common_constants_1.BcCommonConstants.BC_FLOAT_MENU_TOOGLE_CLASS);
        buttonElement.toggleAttribute(common_constants_1.BcCommonConstants.DISABLED, action.disabled || false);
        buttonElement.setAttribute(common_constants_1.BcCommonConstants.ARIA_LABEL, action.actionId);
        buttonElement.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_ID, action.actionId);
        var icon = this.getIcon(action);
        buttonElement.appendChild(icon);
        return buttonElement;
    };
    BcDataTableActionsCell.prototype.findById = function (id) {
        for (var _i = 0, _a = this.bcDataTableConfig.data; _i < _a.length; _i++) {
            var dataArrayByRow = _a[_i];
            var objetoId = dataArrayByRow.find(function (item) { return item.type === 'id' && item.value == id; });
            if (objetoId) {
                return dataArrayByRow;
            }
        }
        return null;
    };
    BcDataTableActionsCell.prototype.handleActionClick = function (event) {
        var clickedElement = event.target;
        if (event.type === common_constants_1.BcCommonConstants.EVENT_CLICK ||
            (event instanceof KeyboardEvent && event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ENTER)) {
            var clickedRow = clickedElement.closest(common_constants_1.BcCommonConstants.TR_TAG);
            var clickedRowId = clickedRow.getAttribute(bc_data_table_constants_1.BcDataTableConstansts.ROW_ID);
            var clickedObject = this.findById(clickedRowId);
            var actionId = clickedElement.getAttribute(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_ID);
            this.callRowActions(actionId, clickedObject);
        }
    };
    return BcDataTableActionsCell;
}());
exports.BcDataTableActionsCell = BcDataTableActionsCell;
